import { fetchAPI } from './FetchAPIWrapper';

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r && 0x3 | 0x8);
        return v.toString(16);
    });
}

async function LMFTFY(searchParams) {
    return fetchAPI.get(`/api/LMFTFY/${searchParams}`)
    .then(LMFTFYData => {
        return LMFTFYData;
    }).catch(error => {
        window.apiError(error);
    });
}

function fetchCopy(GUID){
    const LMFTFYUrl = `${window.location.origin}/q?search=${GUID}`;
    navigator.clipboard.writeText(LMFTFYUrl).then(function () {
        let generatedLink = document.getElementsByClassName('page-generated')[0];
        generatedLink.classList.add('active');
        setTimeout(function () {
            generatedLink.classList.remove('active');
        }, 5000);
    }, function (err) {
        console.error('Could not copy text: ', err);
    });
}

async function generateLMFTFYLink(url, mainSearch) {
    const GUID = uuidv4();
    let LMFTFYsearchKey = {
        Url: url,
        GUID: GUID,
        searchQuery: mainSearch
    };
    
    fetchAPI.post('/api/LMFTFY', {
        body: LMFTFYsearchKey
    })
    .then(() => {
        fetchCopy(GUID);
    }).catch(error => {
        window.apiError(error);
    }); 
}

export { LMFTFY, generateLMFTFYLink };
